import {
  CANVAS_OPEN_FILE_MANAGER_EVENT,
  getEditor,
  LAYERS_TOOL_ID,
  openPanelInCanvas,
  SITE_ACTIONS_TOOL_ID,
} from 'agentable-canvas/whiteboard';

/** Toggle the tldraw layers shape-tree panel via the overflow toolbar tool. */
export function toggleLayersPanel(): void {
  const editor = getEditor();
  if (!editor) return;
  if (editor.getCurrentToolId() === LAYERS_TOOL_ID) {
    editor.setCurrentTool('select');
    return;
  }
  editor.setCurrentTool(LAYERS_TOOL_ID);
}

/** Toggle the site-actions overflow tool (publish/edit bar bridge). */
export function toggleSiteActionsTool(): void {
  const editor = getEditor();
  if (!editor) return;
  if (editor.getCurrentToolId() === SITE_ACTIONS_TOOL_ID) {
    editor.setCurrentTool('select');
    return;
  }
  editor.setCurrentTool(SITE_ACTIONS_TOOL_ID);
}

/** Open or focus the file-manager panel for the active site. */
export function openFileManagerPanel(siteId: string | null): void {
  if (!siteId) return;
  openPanelInCanvas('file-manager', {
    focus: true,
    preserveZoom: true,
    panelProps: {
      siteId,
      __siteId: siteId,
      __title: 'File Manager',
    },
  });
}

/** Dispatch the canvas event that FileManagerBridge listens for. */
export function dispatchOpenFileManager(): void {
  window.dispatchEvent(
    new CustomEvent(CANVAS_OPEN_FILE_MANAGER_EVENT, { bubbles: true, composed: true }),
  );
}
